import React, { useEffect, useState } from "react";
import { Row, Spinner } from "react-bootstrap";
import Box from "@mui/material/Box";
import APICom from "../../../utils/helpers/APICom.js";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import PersistStorage from "../../../utils/helpers/PersistStorage.js";
import GridControl from "../../Controls/gridControl.js";
import * as XLSX from "xlsx";
import saveIcon from "../../../assets/Images/CommonImages/save.png";
import clearFilterIcon from "../../../assets/Images/CommonImages/clearFilter.png";
import RoboCallNotification from "./RoboCallNotifications/RoboCallLogs.js";

const Notificationlogs = () => {
return (
  <>
  <RoboCallNotification></RoboCallNotification>
  </>
  
);
};

export default Notificationlogs;